// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-loader__background {
  z-index: 9999;
  background: #ecf0f5;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding-top: 0;
  display: flex;
  position: fixed;
  inset: 0 auto auto 0;
  overflow: auto;
}

.app-loader__content {
  min-width: 600px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/AppLoader/styles/AppLoader.css","webpack://./services/frontend/app/containers/AppLoader/styles/AppLoader.css"],"names":[],"mappings":"AADA;ECEE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".app-loader__background {\n  background: #ecf0f5;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: auto;\n  position: fixed;\n  z-index: 9999;\n  bottom: auto;\n  height: 100vh;\n  left: 0;\n  top: 0;\n  padding-top: 0;\n  right: auto;\n  width: 100vw;\n}\n\n.app-loader__content {\n  min-width: 600px;\n}\n",".app-loader__background {\n  z-index: 9999;\n  background: #ecf0f5;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  padding-top: 0;\n  display: flex;\n  position: fixed;\n  inset: 0 auto auto 0;\n  overflow: auto;\n}\n\n.app-loader__content {\n  min-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
